import React, { useState } from "react";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Icon from "../../../components/AppIcon";

const DiscountModal = ({ open, onClose, tenant, onApply }) => {
  const [discount, setDiscount] = useState("");
  const [plans, setPlans] = useState({
    growth: false,
    essential: false,
  });

  if (!open) return null;

  const handleCheckboxChange = (plan) => {
    setPlans((prev) => ({
      ...prev,
      [plan]: !prev[plan],
    }));
  };

  const handleApply = () => {
    const selectedPlans = Object.keys(plans).filter((p) => plans[p]);

    if (!discount || selectedPlans.length === 0) return;

    onApply({
      discount,
      plans: selectedPlans, // ["growth", "essential"]
    });

    setDiscount("");
    setPlans({ growth: false, essential: false });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-card rounded-lg w-full max-w-md p-6 shadow-lg">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-text-primary">
            Apply Discount
          </h3>
          <button onClick={onClose}>
            <Icon name="X" size={18} />
          </button>
        </div>

        {/* Tenant */}
        <p className="text-sm text-text-secondary mb-4">
          Tenant: <span className="font-medium">{tenant?.companyName}</span>
        </p>

        {/* Discount Input */}
        <div className="mb-4">
          <label className="block text-sm font-medium text-text-secondary mb-1">
            Discount (%)
          </label>
          <Input
            type="number"
            placeholder="Enter discount percentage"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            min={0}
            max={100}
          />
        </div>

        {/* Plan Selection */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-text-secondary mb-2">
            Apply discount to plans
          </label>

          <div className="space-y-2">
            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={plans.growth}
                onChange={() => handleCheckboxChange("growth")}
                className="w-4 h-4 text-primary bg-input border-border rounded focus:ring-primary"
              />
              <span className="text-sm text-text-primary">Growth</span>
            </label>

            <label className="flex items-center space-x-2 cursor-pointer">
              <input
                type="checkbox"
                checked={plans.essential}
                onChange={() => handleCheckboxChange("essential")}
                className="w-4 h-4 text-primary bg-input border-border rounded focus:ring-primary"
              />
              <span className="text-sm text-text-primary">Essential</span>
            </label>
          </div>
        </div>

        {/* Actions */}
        <div className="flex justify-end space-x-2">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={handleApply}
            disabled={
              !discount || (!plans.growth && !plans.essential)
            }
          >
            Apply Discount
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DiscountModal;
